// extracted by mini-css-extract-plugin
export default {"pagination_container":"AuthorList_pagination_container__8alLz"};